<template>
  <div>
    <!--<div>
      <vue-single-select
        v-show="$bus.getRole()=='admin'"
        class="m-2 col-md-11"
        v-model="SelectedMerchantItem"
        option-label="merchant_name"
        :options="Merchants"
        :maxResults=500
        :required="true"
      ></vue-single-select>
      <b-form-select id="store_select" v-model="selectedStore" @change="storeServiceChanged" class="col-md-3 m-2">
        <option :value="store" v-for="store in storeList" :key="store.id">{{store.store_name}}</option>
      </b-form-select>
      <b-form-select id="service_select" v-model="selectedServiceItem" @change="storeServiceChanged" class="col-md-4 m-2">
        <option :value="service" v-for="service in TicketServiceList" :key="service.merchant_service_id">{{service.service_name}}</option>
      </b-form-select>
    </div>-->
    <populate-form
      formTitle="核銷日曆查看"
      fkey="sx01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      @customValueChanged="storeServiceChanged"
    ></populate-form>
    <div class="calendar-wrapper">
      <full-calendar
        ref="calendar"
        :events="eventList"
        @view-render="changeViewPeriod"
        @event-selected="showDetail"
        :config="options"
      ></full-calendar>
    </div>
    <b-modal
      id="showEvent"
      ref="eventModal"
      v-model="modalShow"
      hide-footer
      centered
    >
      <b-form>
        <label>服務核銷時間：</label>
        <b-form-input class="readonly-input" disabled type="text" v-model="popupMsg.ticket_scan_time" ></b-form-input>
        <label>用戶持票人姓名：</label>
        <b-form-input class="readonly-input" disabled type="text" v-model="popupMsg.user_name" ></b-form-input>
        <label>核銷票卷票號：</label>
        <b-form-input class="readonly-input" disabled type="text" v-model="popupMsg.ticket_no" ></b-form-input>
        <label>服務分店：</label>
        <b-form-input class="readonly-input" disabled type="text" v-model="popupMsg.store_name" ></b-form-input>
        <label>服務課程名稱：</label>
        <b-form-input class="readonly-input" disabled type="text" v-model="popupMsg.service_name" ></b-form-input>
        <label>服務課程估計需時平均分鐘數：</label>
        <b-form-input class="readonly-input" disabled type="text" v-model="popupMsg.service_standard_minutes" ></b-form-input>
      </b-form>
    </b-modal>
  </div>
</template>

<script>

import { FullCalendar } from 'vue-full-calendar'
import 'fullcalendar/dist/fullcalendar.css'
import 'fullcalendar/dist/locale/zh-tw'

import {
  apiGetMerchantList,
  apiGetMerchantById 
} from '@/api/AdminManage'

import {
  apiGetExecutionEvents,
  apiGetTicketStatus
} from '@/api/Merchant.js'

export default {
  name: 'ServiceExecutionView',
  components: {
    FullCalendar,
  },
  data: function () {
    return {
      SelectedMerchantId:0,
      CachedMerchant: {},
      filterInitialized: false,
      filterData: {
        SelectedMerchantItem: null,
        selectedStore: null,
        selectedServiceItem: null,
      },
      // 別寫這 之後搬到created或mounted裡,可以處理時間差載入傳下去的資料
      filterOptions: [
        {
          'componentType':'span',
          'placeholder':'選擇供應商',
          'akey':'span1',
          'col':2,
          'hide':this.$bus.getRole()!=='admin',
        },
        {
          'componentType':'vue-single-select',
          'optionVar':'Merchants',
          'defaultValue':null,
          'akey':'SelectedMerchantItem',
          'optionLabel':'merchant_name',
          'col':7,
          'placeholder':'指定供應商查看',
          'title':'切換選擇即更新下方顯示,選擇任一供應商後才顯示',
          'hide':this.$bus.getRole()!=='admin',
        },
        {
          'componentType':'text',
          'placeholder':'輸入完整AA票號查看核銷狀態',
          'akey':'ticket_no',
          'col':3,
          'centerText':true,
          'hide':(this.checkMobile()||this.$bus.getRole()!=='admin'),
          'execCallback':this.showTicketUseStatus,
        },
        {
          'componentType':'b-form-select',
          'optionVar':'storeList',
          'defaultValue':null,
          'akey':'selectedStore',
          'optionLabel':'store_name',
          'col':3,
          'placeholder':(this.$bus.getRole()==='admin'?'全部分店':'')
        },
        {
          'componentType':'b-form-select',
          'optionVar':'TicketServiceList',
          'defaultValue':null,
          'akey':'selectedServiceItem',
          'optionLabel':'service_name',
          'col':6,
          'placeholder':(this.$bus.getRole()==='admin'?'全部課程':'')
        },
        {
          'componentType':'b-button',
          'placeholder':'查詢票號狀態',
          'akey':'btn-check',
          'col':3,
          'title':"此按鈕只做票號狀態簡易查詢與下方行事曆無關,供應商/分店/課程切換後即更新數據,切換日期檢視",
          'hide':(this.checkMobile()||this.$bus.getRole()!=='admin'),
          'execCallback':this.showTicketUseStatus,
        },
      ],
      showDate: new Date(),
      eventList:[],
      CalendarState:Object,
      myDateClasses: {},
      Merchants: [],
      SelectedMerchant: Object,
      storeList: [],
      selectedStore: {},
      TicketServiceList: [],
      selectedServiceItem: {},
      cacheStartDate: null,
      cacheEndDate: null,
      options: {
        allDaySlot: false,
        scrollTime: "08:30:00",
        locale:"zh-tw",
        editable:false,
        selectable:false,
        header: {
          left:   'prev,next today',
          center: 'title',
          right:  'agendaWeek,agendaDay'
        },
      },
      modalShow:false,
      popupMsg: {
        ticket_scan_time:'',
        user_name:'',
        ticket_no:'',
        store_name:'',
        service_name:'',
        service_standard_minutes:'',
      },
    }
  },
  props: [

  ],
  methods: {
    setShowDate(d) {
				this.showDate = d;
    },
    changeViewPeriod() {
      // current date range is so hard to retrieve= =
      this.CalendarState = {
        'periodStart': this.$refs.calendar.fireMethod("getView").start.format(),
        'periodEnd': this.$refs.calendar.fireMethod("getView").end.format()
      }
      if (this.cacheStartDate === null) {
        this.cacheStartDate = this.$refs.calendar.fireMethod("getView").start.format()
        this.cacheEndDate = this.$refs.calendar.fireMethod("getView").start.format()
      }
      // 不刷新數據庫即時資料,剛撈過的就不重撈
      if (this.CalendarState.periodStart < this.cacheStartDate || this.CalendarState.periodEnd > this.cacheEndDate) {
        this.getEvents()
      }
    },
    storeServiceChanged(upd) {
      if (!this.filterInitialized) {
        return
      }
      let need_load_event = false
      if (upd.key === 'SelectedMerchantItem') {
        this.loadMerchantById(upd.val?upd.val.merchant_id:0)
        if (this.$bus.getRole() === 'admin' && upd.val && upd.val.merchant_id ) {
          need_load_event = true
        }
      }
      else if (this.filterData.SelectedMerchantItem && this.filterData.SelectedMerchantItem.merchant_id) {
        need_load_event = true
      }
      if (need_load_event) {
        setTimeout(() => {
          // cache是針對同一組資料的結果,所以換分店或課程時得清掉重撈
          this.eventList = []
          this.cacheStartDate = this.$refs.calendar.fireMethod("getView").start.format()
          this.cacheEndDate = this.$refs.calendar.fireMethod("getView").start.format()
          this.getEvents()
        }, 200);
      }
    },
    showDetail(cEvent) {
      this.popupMsg = cEvent.exe_obj
      this.modalShow = true
    },
    getEvents(vm) {
      if (vm === undefined) {
        vm = this
      }
      if (!vm.filterInitialized) {
        //不稍等一下的話,mounted設定預設分店與課程時會額外觸發兩次多餘重複的查詢
        setTimeout(() => {
          vm.filterInitialized = true  
        }, 50);
      }
      // 必要條件只有商家id,分店與課程沒選預設該商家全部
      if (!vm.filterData.SelectedMerchantItem || !vm.filterData.SelectedMerchantItem.merchant_id) {
        return
      }
      let view_start_date = vm.CalendarState.periodStart
      let view_end_date = vm.CalendarState.periodEnd
      // 初始化時null === null與換店換課程緩存起訖同一天才要例外處理
      // CalendarState是和日曆狀態跑不受程式控制,所以控制判斷就做在緩存起訖日期上
      // 
      // if (vm.cacheStartDate !== vm.cacheEndDate) {
      //   // 只有超過cache範圍才會需要撈,判斷是往前還是往後,一次抓60天append
      //   if (view_start_date < this.cacheStartDate) {
      //     view_start_date = this.getDateByStr(this.cacheStartDate,-60)
      //     view_end_date = this.getDateByStr(this.cacheStartDate,-1)
      //     // 還沒撈成功就更新有風險,但先不管(let參數進callback就沒了)
      //     this.cacheStartDate = view_start_date
      //   }
      //   else {
      //     view_start_date = this.getDateByStr(this.cacheEndDate,1)
      //     view_end_date = this.getDateByStr(this.cacheEndDate,60)
      //     // 同上,有風險
      //     this.cacheEndDate = view_end_date
      //   }
      // }
      // else {
      //   // 剛進來或剛換分店/課程時
      //   view_start_date = this.getDateByStr(this.cacheStartDate,-60)
      //   view_end_date = this.getDateByStr(this.cacheStartDate,60)
      //   this.cacheStartDate = view_start_date
      //   this.cacheEndDate = view_end_date
      // }
      let Param = {
        'module':'merchant',
        'method':'getExecutionEvents',
        'merchant_id':vm.filterData.SelectedMerchantItem.merchant_id,
        'merchant_store_id':vm.filterData.selectedStore?vm.filterData.selectedStore.merchant_store_id:0,
        'merchant_service_id': vm.filterData.selectedServiceItem?vm.filterData.selectedServiceItem.merchant_service_id:0,
        'not_group_by_day':0,
        'view_start_date':view_start_date,
        'view_end_date':view_end_date
      }

      Param.view_start_date = Param.view_start_date.replaceAll('/', '-')
      Param.view_end_date = Param.view_end_date.replaceAll('/', '-')

      apiGetExecutionEvents(Param).then(function(resp){
        let data = resp.data
        // eslint-disable-next-line
        let append = vm.parseEvents(data.data)
        // append (排序有助於之後找出起訖日期的最早時間,但動態改options.scrollTime沒用,就先不做)
        vm.eventList = vm.eventList.concat(append) //.sort((a,b) => (a.start > b.start) ? 1 : ((b.start > a.start) ? -1 : 0))
        vm.eventDirty = false
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })

      // vm.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     // eslint-disable-next-line
      //     let append = vm.parseEvents(data.data)
      //     // append (排序有助於之後找出起訖日期的最早時間,但動態改options.scrollTime沒用,就先不做)
      //     vm.eventList = vm.eventList.concat(append) //.sort((a,b) => (a.start > b.start) ? 1 : ((b.start > a.start) ? -1 : 0))
      //     vm.eventDirty = false
      // },vm)
    },
    parseEvents(events) {
      let eventList = []
      // key as day object foreach
      for (let [key_date, exec_events] of Object.entries(events)) {
        for (let i=0;i<exec_events.length;i++) {
          eventList.push({
            // id is required for event-click(or that event will not trigger)
            id:'e_'+key_date+'_'+exec_events[i].service_execution_id,
            title: exec_events[i].user_name,
            start: exec_events[i].start_time_rounded,
            end: exec_events[i].end_time_rounded,
            exe_obj:exec_events[i],
          })
        }
      }
      return eventList
    },
    loadMerchantById(merchant_id) {
      // 回到預設(event也應清掉,都換檢視供應商了)
      this.eventList = []
      this.storeList = []
      this.TicketServiceList = []
      if (!merchant_id) {
        this.filterData.SelectedMerchantItem = null
        this.filterData.selectedStore = null
        this.filterData.selectedServiceItem = null
        return
      }
      // 先判斷cache
      if (this.CachedMerchant.hasOwnProperty('m_'+merchant_id)) {
        this.storeList = this.CachedMerchant['m_'+merchant_id].merchant_stores
        this.TicketServiceList = this.CachedMerchant['m_'+merchant_id].merchant_ticket_projects
        return
      }
      else {
        this.FocusedMerchantId = merchant_id
        // 再抓資料庫放cache
        let Param = {
          'module':'admin_manage',
          'method':'get_merchant_by_id',
          'merchant_id':merchant_id,
        }

        let vm = this
        apiGetMerchantById(Param).then(function(resp){
          let data = resp.data
          // eslint-disable-next-line
          data.data.merchant_stores = vm.parseAdminStores(data.data.merchant_stores)
          vm.storeList = data.data.merchant_stores
          let services = []
          for (let i=0;i<data.data.merchant_ticket_projects.length;i++) {
            let item = {
                ticket_project_service_item_id:data.data.merchant_ticket_projects[i].ticket_services[0].ticket_project_service_item_id,
                merchant_service_id:data.data.merchant_ticket_projects[i].ticket_services[0].merchant_service_id,
                service_name:data.data.merchant_ticket_projects[i].ticket_services[0].service_name,
                product_id:data.data.merchant_ticket_projects[i].product_id
            }
            services.push(item)
          }
          data.data.merchant_ticket_projects = services
          // vm.SelectedMerchantItem.merchant_ticket_projects = services
          vm.TicketServiceList = services
          vm.CachedMerchant['m_'+vm.FocusedMerchantId] = data.data
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
        })
        // this.$bus.apiCall(Param, function (data, vm) {
        //   if (data.ok === 0) {
        //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
        //     return
        //   }
        //   // eslint-disable-next-line
        //   data.data.merchant_stores = vm.parseAdminStores(data.data.merchant_stores)
        //   vm.storeList = data.data.merchant_stores
        //   let services = []
        //   for (let i=0;i<data.data.merchant_ticket_projects.length;i++) {
        //     let item = {
        //         ticket_project_service_item_id:data.data.merchant_ticket_projects[i].ticket_services[0].ticket_project_service_item_id,
        //         merchant_service_id:data.data.merchant_ticket_projects[i].ticket_services[0].merchant_service_id,
        //         service_name:data.data.merchant_ticket_projects[i].ticket_services[0].service_name,
        //         product_id:data.data.merchant_ticket_projects[i].product_id
        //     }
        //     services.push(item)
        //   }
        //   data.data.merchant_ticket_projects = services
        //   // vm.SelectedMerchantItem.merchant_ticket_projects = services
        //   vm.TicketServiceList = services
        //   vm.CachedMerchant['m_'+vm.FocusedMerchantId] = data.data
        // },this)
      }
    },
    parseAdminStores(stores) {
      let parsed_stores = []
      for (let i=0;i<stores.length;i++) {
        let store = stores[i]
        store.merchant_store_id = store.id
        delete store['id']
        parsed_stores.push(store)
      }
      return parsed_stores
    },
    showTicketUseStatus () {
      if (this.filterData.ticket_no === undefined || !this.filterData.ticket_no) {
        return
      }
      if (!this.filterData.ticket_no || this.filterData.ticket_no.trim().length !== 10) {
        this.$bus.fnShowInfo('請輸入完整AA票號')
      }
      let Param = {
        'module':'merchant',
        'method':'getTicketStatus',
        'ticket_no':this.filterData.ticket_no,
      }
      let vm = this
      apiGetTicketStatus(Param).then(function(resp){
        let data = resp.data
        // eslint-disable-next-line
        let usages = data.data.usages
        let informMsg = '票號：'+ vm.filterData.ticket_no + '<br>'+usages[0].ticket_project_name+'('+usages[0].buyer+'於'+usages[0].print_time+'購買）'
        if (usages.length > 1) {
          informMsg += '<br>此票卷可使用次數為'+usages.length+'<br>'
        }
        for (let i=0;i<usages.length;i++) {
          if (usages[i].ticket_scan_time) {
            informMsg += '已於'+usages[i].ticket_scan_time+'在'+usages[i].service_store+'使用<br/>'
          }
          else if (usages[i].reserve_time) {
            informMsg += '已於'+usages[i].reserve_time+'在'+usages[i].reserve_store+'預約'+usages[i].reserve_start+'開始的時段(尚未到店使用)<br/>'
          }
          else {
            informMsg += '尚未預約使用<br>'
          }
        }
        vm.$bus.fnShowInfo(informMsg)
        vm.filterData.ticket_no = ""
        vm.$refs.filterForm.refreshModelVar()
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('查看失敗:'+data.msg)
            return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('查看失敗:'+data.msg)
      //       return
      //     }
      //     // eslint-disable-next-line
      //     let usages = data.data.usages
      //     let informMsg = '票號：'+ vm.filterData.ticket_no + '<br>'+usages[0].ticket_project_name+'('+usages[0].buyer+'於'+usages[0].print_time+'購買）'
      //     if (usages.length > 1) {
      //       informMsg += '<br>此票卷可使用次數為'+usages.length+'<br>'
      //     }
      //     for (let i=0;i<usages.length;i++) {
      //       if (usages[i].ticket_scan_time) {
      //         informMsg += '已於'+usages[i].ticket_scan_time+'在'+usages[i].service_store+'使用<br/>'
      //       }
      //       else if (usages[i].reserve_time) {
      //         informMsg += '已於'+usages[i].reserve_time+'在'+usages[i].reserve_store+'預約'+usages[i].reserve_start+'開始的時段(尚未到店使用)<br/>'
      //       }
      //       else {
      //         informMsg += '尚未預約使用<br>'
      //       }
      //     }
      //     vm.$bus.fnShowInfo(informMsg)
      //     vm.filterData.ticket_no = ""
      //     vm.$refs.filterForm.refreshModelVar()
      //     return
      // },this)
    }
  },
  computed: {
    
  },
  created: function () {
    /*const date = new Date()
    const period_start_date = new Date(date.getFullYear,date.getMonth,1)
    const period_end_date = new Date(date.getFullYear,date.getMonth+1,0)
    
    // 預設本月第一天到最後一天,切換會刷新,初始值要自己先設定
    this.CalendarState = {
      'periodStart': this.toISODateString(period_start_date),
      'periodEnd': this.toISODateString(period_end_date),
    }
    */
    // 用戶使用時,預讀取票卷列表
    if (!this.$bus.session) {
      // 要重登入
      this.$bus.session = undefined
    }
  },
  mounted () {
    //this.$refs.filterForm.initDefault()
    // 如已登入則放入Merchants與SelectedMerchantItem
    if (this.$bus.session && this.$bus.session != 'undefined' && this.$bus.getRole() === 'merchant' ) {
      let myMerchant = {
        'merchant_id': this.$bus.session.merchant_id,
        'merchant_name': this.$bus.session.merchant_name,
      }
      this.Merchants.push(myMerchant)
      this.filterData.SelectedMerchantItem = myMerchant
      this.storeList = this.CpObj(this.$bus.session.stores)
      if (this.storeList.length > 1) {
        this.storeList.unshift({'store_name':'全部分店','merchant_store_id':0})
      }
      this.filterData.selectedStore = this.storeList[0]
      let service_items = []
      for (let i=0;i<this.$bus.session.ticket_projects.length;i++) {
        service_items.push({
          'merchant_service_id': this.$bus.session.ticket_projects[i].service_items[0].merchant_service_id,
          'service_name':this.$bus.session.ticket_projects[i].service_items[0].service_name
        })
      }
      this.TicketServiceList = service_items
      if (this.TicketServiceList.length > 1) {
        this.TicketServiceList.unshift({'service_name':'全部課程','merchant_service_id':0})
      }
      this.filterData.selectedServiceItem = this.TicketServiceList[0]
      this.getEvents()
    }
    else {
      let Param = {
        'module':'admin_manage',
        'method':'get_merchant_list',
        'merchant_name':'',
      }
      let vm = this
      apiGetMerchantList(Param).then(function(resp){
        let data = resp.data
        // eslint-disable-next-line
        vm.Merchants = data.data
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     // eslint-disable-next-line
      //     vm.Merchants = data.data
      // },this)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fc-day-grid {
  display:none;
}

.calendar-wrapper {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size:2.5vh;
  color: #2c3e50;
  height: 67vh;
  width: 95vw;
  margin-left: auto;
  margin-right: auto;
}

.readonly-input {
  text-align:center;
}

</style>
<style>
/* set this for mobile view became too short to use */
.fc-time-grid-container {
  min-height:45vh;
  max-height:65vh;
}

.fc-toolbar h2 {
  font-size: 1.8rem;
}

.fc-day-header {
  font-size: 0.9rem;
}
</style>
